import {
	ListBase,
	ListToolbar,
	Pagination,
	SimpleListLoading,
	useGetIdentity,
	useListContext
} from 'react-admin';
import { Box, Stack } from '@mui/material';
import { ListActions } from '../../../components/ListActions';
import { OBJECTS_TYPES } from '../../../constants';
import { ApartmentCard } from '../ApartmentCard';
import { ApartmentsFilter } from '../ApartmentsFilter';

export const ApartmentsList = () => {
	const { identity } = useGetIdentity();
	if (!identity) return null;

	return (
		<ListBase
			resource={OBJECTS_TYPES.PROPERTIES}
			perPage={25}
			sort={{ field: 'created_at', order: 'DESC' }}
			filter={{ property_type: OBJECTS_TYPES.APARTMENTS }}
		>
			<ApartmentsListLayout />
		</ListBase>
	);
};

const ApartmentsListLayout = () => {
	const { data, isPending, error } = useListContext();

	if (isPending) {
		return <SimpleListLoading hasLeftAvatarOrIcon hasSecondaryText />;
	}
	if (error) {
		return null;
	}

	return (
		<Stack direction="row" gap={3}>
			<ApartmentsFilter />
			<Stack sx={{ width: '100%' }}>
				<Stack sx={{ width: '100%' }}>
					<ListToolbar
						actions={
							<ListActions
								sortOptions={[
									{
										id: 'created_at',
										label: 'Дата створення'
									},
									{
										id: 'name',
										label: 'Назва'
									},
									{
										id: 'rent_usd_object_price',
										label: 'Ціна оренди'
									},
									{
										id: 'sale_usd_object_price',
										label: 'Ціна продажу'
									},
									{
										id: 'area',
										label: 'Площа'
									}
								]}
							/>
						}
					/>
				</Stack>
				<Box
					mt={2}
					width="100%"
					gap={2}
					display="grid"
					justifyItems="center"
					gridTemplateColumns="repeat(auto-fill, minmax(230px, 1fr))"
				>
					{data?.map(data => <ApartmentCard key={data.id} data={data} />)}
				</Box>
				<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
			</Stack>
		</Stack>
	);
};
